import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

interface Card {
  access_key: string;
  last_four: string;
}

interface CardsWithPasswordResponse {
  cards: Card[];
  require_password?: boolean;
  error?: {
    type?: string;
    message?: string;
  };
}

interface RemoveCardResponse {
  success?: boolean;
  require_password?: boolean;
  error?: {
    message?: string;
  };
}

interface SetPasswordResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

interface ResetPasswordResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

export async function accountCardsWithPassword(loginKey: string, paymentPassword?: string) {
  const body: Record<string, unknown> = { login_key: loginKey };
  if (paymentPassword) {
    body.payment_password = paymentPassword;
  }
  return post<CardsWithPasswordResponse>(API_ENDPOINTS.CARDS, body);
}

export async function removeCard(loginKey: string, accessKey: string, paymentPassword?: string) {
  const body: Record<string, unknown> = { login_key: loginKey, access_key: accessKey };
  if (paymentPassword) {
    body.payment_password = paymentPassword;
  }
  return post<RemoveCardResponse>(API_ENDPOINTS.REMOVE_CARD, body);
}

export async function setPurchasePassword(loginKey: string, password: string, currentPassword?: string) {
  const body: Record<string, unknown> = { login_key: loginKey, password };
  if (currentPassword) {
    body.current_password = currentPassword;
  }
  return post<SetPasswordResponse>(API_ENDPOINTS.PASSWORD_SET, body);
}

export async function resetPurchasePassword(loginKey: string) {
  return post<ResetPasswordResponse>(API_ENDPOINTS.PASSWORD_RESET_PAYMENT, { login_key: loginKey });
}

export default {
  accountCardsWithPassword,
  removeCard,
  setPurchasePassword,
  resetPurchasePassword,
};
